import { Button, Chip } from "@mui/material";
import React from "react";
import { CompositeAssetsForm } from "./CompositeAssetsForm";
import { CompositeAssetsTable } from "./CompositeAssetsTable";
import AddIcon from "@mui/icons-material/Add";
import {
  AreaUnit,
  CompositeAssetPreset,
  CompositeAssetRequest,
  CompositePresetType,
} from "../../types/api.types";
import { DesignationType } from "common/types/comparableFields.types";
import { useTranslation } from "react-i18next";

interface CompositeAssetsProps {
  propertyId: string;
  pricePredictionId?: string;
  isCustomer?: boolean;
  hideValue?: boolean;
  shouldCheckForUniqueNr?: boolean;
}

export const CompositeAssets: React.FC<CompositeAssetsProps> = ({
  propertyId,
  isCustomer,
  pricePredictionId,
  hideValue,
  shouldCheckForUniqueNr,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [selectedPreset, setSelectedPreset] =
    React.useState<CompositeAssetPreset | null>(null);

  const presets: CompositeAssetPreset[] = [
    {
      name: t("propertyDetails.compositeAssets.parkingOverground"),
      designationTypeId: DesignationType.OtherEngineeringStructures,
      areaUnit: AreaUnit.SqMeters,
      presetType: CompositePresetType.ParkingOverground,
    },
    {
      name: t("propertyDetails.compositeAssets.parkingUnderground"),
      designationTypeId: DesignationType.Garage,
      areaUnit: AreaUnit.SqMeters,
      presetType: CompositePresetType.ParkingUnderground,
    },
    {
      name: t("propertyDetails.compositeAssets.storage"),
      designationTypeId: DesignationType.OtherSubFarm,
      areaUnit: AreaUnit.SqMeters,
      presetType: CompositePresetType.Storage,
    },
    {
      name: t("propertyDetails.compositeAssets.plotArea"),
      designationTypeId: DesignationType.PlotArea,
      areaUnit: AreaUnit.Hectares,
      presetType: CompositePresetType.PlotArea,
    },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        {presets.map((preset, index) => (
          <Chip
            key={index}
            icon={<AddIcon />}
            label={preset.name}
            onClick={() => {
              setSelectedPreset(preset);
              setOpen(true);
            }}
            variant="outlined"
          />
        ))}
      </div>

      <CompositeAssetsTable
        propertyId={propertyId}
        isCustomer={isCustomer}
        pricePredicitionId={pricePredictionId}
        hideValue={hideValue}
        shouldCheckForUniqueNr={shouldCheckForUniqueNr}
      />
      <CompositeAssetsForm
        isCustomer={isCustomer}
        open={open}
        onClose={() => {
          setOpen(false);
          setSelectedPreset(null);
        }}
        propertyId={propertyId}
        preset={selectedPreset}
        hideValue={hideValue}
      />
      <Button
        onClick={() => {
          setOpen(true);
        }}
        variant="contained"
        startIcon={<AddIcon />}
        style={{
          alignSelf: "end",
          marginTop: "20px",
        }}
      >
        {t("propertyDetails.compositeAssets.addAsset")}
      </Button>
    </div>
  );
};
